interface DeviceInfo {
  browser: string;
  deviceType: string;
}

export function parseUserAgent(userAgent: string | null): DeviceInfo {
  if (!userAgent) {
    return {
      browser: 'Unknown Browser',
      deviceType: 'Unknown Device'
    };
  }

  try {
    let browser = 'Unknown Browser';
    let deviceType = 'Desktop'; // Default to Desktop

    // Browser detection
    if (userAgent.includes('Firefox')) browser = 'Firefox';
    else if (userAgent.includes('Chrome')) browser = 'Chrome';
    else if (userAgent.includes('Safari')) browser = 'Safari';
    else if (userAgent.includes('Edge')) browser = 'Edge';
    else if (userAgent.includes('Opera')) browser = 'Opera';

    // Device type detection
    if (/Mobile|Android|iPhone|iPad|iPod/i.test(userAgent)) {
      if (/iPad|Tablet|PlayBook/i.test(userAgent)) {
        deviceType = 'Tablet';
      } else {
        deviceType = 'Mobile';
      }
    }

    return { browser, deviceType };
  } catch {
    return {
      browser: 'Unknown Browser',
      deviceType: 'Unknown Device'
    };
  }
} 